import React, { useEffect, useState, useRef } from "react";
import Attachments from "./modals/Attachments";
import Skeleton from "react-loading-skeleton";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EditIcon } from "../assets/Icons";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";

const UserResponseList = ({}) => {
  const { responseId } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachment, setAttachment] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSite, setSelectedSite] = useState({});

  const fetchQestions = async () => {
    try {
      let { data } = await axios.get(`${configData.config.API_URL}/api/site/response/${responseId}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      setQuestions(data.data);
      setSiteOptions(data.data.subSiteList?.map((item) => ({ label: item.name, value: item.uuid })));
      setSelectedSite({ label: data?.data?.site?.name, value: data?.data?.site?.uuid });
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResponseChange = (uniqueKey, responseId, answer) => {
    const ques = questions?.data;
    ques.forEach((item) => {
      if (item.uniqueKey == uniqueKey) {
        item.responseId = responseId;
        item.answer = answer;
      }
    });
    setQuestions((prev) => ({ ...prev, data: ques }));
  };

  const handleView = (data) => {
    setAttachment(data);
    setShowAttachments(true);
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const filteredRes = questions?.data?.map(({ uniqueKey, options, ...rest }) => rest);

      await axios.post(
        `${configData.config.API_URL}/api/application/response/update`,
        { data: filteredRes, siteId: selectedSite.value, responseId: responseId },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.log(error.message);
    } finally {
      setSaving(false);
      fetchQestions();
    }
  };

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setEditingId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchQestions();
  }, []);

  return (
    <>
      <div className="d-flex gap-2 justify-content-end">
        {!!siteOptions?.length && (
          <div style={{ width: "170px" }}>
            <Select
              options={siteOptions}
              value={selectedSite}
              onChange={(e) => setSelectedSite(e)}
              placeholder="Select a site"
            />
          </div>
        )}
        {userData?.user?.permissions?.includes("MACHINE.ADD") && !loading && (
          <button className="btn btn-danger d-flex align-items-center gap-2" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <div className="spinner-border spinner-border-sm"></div>
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        )}
      </div>
      <div className="table-responsive workflowtb mt-3">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">S.No.</th>
              <th>Question</th>
              <th className="text-center">Response</th>
              <th className="text-center">Attachments</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
                <tr>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td>
                    <Skeleton width="20vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                  <td className="text-center">
                    <Skeleton width="5vw" height="1.4rem" />
                  </td>
                </tr>
              </>
            ) : (
              <>
                {questions.data?.length > 0 &&
                  questions.data.map((e, i) => {
                    const formatResponse = (options, answerId) => {
                      const res = options?.find((item) => item.uuid == answerId).option;
                      return res === "Yes" ? (
                        <span className="good">{res}</span>
                      ) : res === "No" ? (
                        <span className="bad">{res}</span>
                      ) : (
                        <span className="other text-muted">{res}</span>
                      );
                    };

                    return (
                      <tr key={i + 1}>
                        <td className="text-center"> {i + 1} </td>
                        <td>
                          <div className="ques-comment">
                            <span>{e.question}</span>
                            {e.comment && (
                              <span className="comment">
                                {" "}
                                <span> Comment : </span>
                                {e.comment}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="text-center position-relative">
                          {formatResponse(e.options, e.responseId)}
                          <button
                            onClick={() => setEditingId(i)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              marginLeft: "8px",
                            }}
                          >
                            <EditIcon />
                          </button>

                          {editingId === i && (
                            <div
                              ref={dropdownRef}
                              className="custom-dropdown-menu"
                              style={{
                                position: "absolute",
                                top: "80%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                zIndex: 999,
                              }}
                            >
                              <div className="dropdown-menu show" style={{ display: "block", minWidth: "90px" }}>
                                {e?.options.map((opt) => (
                                  <button
                                    key={opt.uuid}
                                    className="dropdown-item"
                                    onClick={() => {
                                      setEditingId(null);
                                      handleResponseChange(e.uniqueKey, opt.uuid, opt.option);
                                    }}
                                  >
                                    {opt.option}
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                        </td>

                        <td className="text-center">
                          {e?.attachments?.length > 0 ? (
                            <Link onClick={() => handleView(e.attachments)}>View</Link>
                          ) : (
                            <div>NA</div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>

      <Attachments showAttachments={showAttachments} setShowAttachments={setShowAttachments} attachment={attachment} />
    </>
  );
};

export default UserResponseList;
